import React, { useState } from "react";
import { Box } from "@mui/material";
import SubTitle from "../../components/common/SubTitle";
import AlertList from "./AlertList";
import TitleBar from "../navbar/TitleBar";
import Navbar from "../navbar/Navbar";
import NavMenu from "../navbar/NavMenu";
import Footer from "../common/Footer";

const Alert = () => {
  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization?.name;
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isUnreadOnly, setIsUnreadOnly] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  return (<>
    <TitleBar />
    <NavMenu />
    <Box sx={{ backgroundColor: "#f5f7f9", minHeight: "100vh", minWidth: "90vw",marginBottom:"8vh" }}>
      <SubTitle title="Alerts" path={`${orgName || "organization"} > Alerts`} />
      <Box sx={{ margin: "0px 40px" }}>
        <AlertList
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          isUnreadOnly={isUnreadOnly}
          startDate={startDate}
          endDate={endDate}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          selectedVehicle={selectedVehicle}
          selectedStatus={selectedStatus}
        />
      </Box>
    </Box>
    <Footer/>
  </>
  );
};

export default Alert;